import React, { useEffect, useState } from 'react';
import { Gender } from '../../configs';
import { ENV } from '../../constants';
import { clsx } from '../../utils/utils';
import Button from '../Button';
import Layout from '../Layout';

import * as styles from './BuildingScreen.module.scss';

export interface BuildingScreenProps {
  onGenderPick: (gender: Gender | null) => void;
}

const BuildingScreen = ({ onGenderPick }: BuildingScreenProps): React.ReactElement => {
  const [dotsNumber, setDotsNumber] = useState(3);
  const [selectedGender, setSelectedGender] = useState(null);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDotsNumber((dotsNumber + 1) % 4);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [dotsNumber]);

  const dots = Array(dotsNumber + 1).join('.');

  function onButtonClick(gender) {
    setSelectedGender(gender);
    setTimeout(
      () => {
        onGenderPick(gender === 'either' ? null : gender);
        setSelectedGender(null);
      },
      ENV === 'development' ? 0 : 300,
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <h2 className={styles.titleContainer}>
            <span className={styles.title}>Building your</span>
            <span className={styles.title}>
              superdev
              <span className={styles.dots}>{dots}</span>
            </span>
          </h2>
          <p className={styles.text}>
            While we work on your superdev let us know how you would like them to look
          </p>
          <p className={clsx(styles.text, styles.smallText)}>
            (You can still change your mind in the next screen)
          </p>
          <div className={styles.answersContainer}>
            <Button
              pressed={selectedGender === 'male'}
              className={clsx(styles.answer, selectedGender === 'male' && styles.selectedAnswer)}
              onClick={() => onButtonClick('male')}
            >
              Male
            </Button>
            <Button
              pressed={selectedGender === 'female'}
              className={clsx(styles.answer, selectedGender === 'female' && styles.selectedAnswer)}
              onClick={() => onButtonClick('female')}
            >
              Female
            </Button>
            <Button
              pressed={selectedGender === 'either'}
              className={clsx(styles.answer, selectedGender === 'either' && styles.selectedAnswer)}
              onClick={() => onButtonClick('either')}
            >
              Gender Diverse
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BuildingScreen;
